



















































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import { ICodeList, IMapFilter } from "@/components/map/types";
import { parseValue } from "@/common/utils";
import Map from "@/components/map/Map";
import { BudgetYear } from "../data/farmland";
import SearchBase from "./search.base";

@Component
export default class SearchLand extends SearchBase {
  @Prop({
    default: null
  }) data: {
    $map: Map;
    filter: IMapFilter
  };

  LandColor(land) : number {
    if (land.fssn_fk || land.farmer_ssn) {
      if (this.User.Organization && this.User.Organization.Code.match(/^DOAE/i)) {
        let n = BudgetYear() - land.fssn_fyy;
        return n==0 ? 2 : n==1 ? 1 : 11;
      } else {
        return 2;
      }
    } else {
      return land.status ? 2 : 0;
    }
  }

  created() {
    this.initialize(this.data);
  }

  async doSearchLandFromDOL() {
    try {
      this.isSearching = true;
      let params:any = {
        pv_id: this.filter.ProvinceCode,
        amp_id: this.filter.AmphoeCode,
        chanode: this.filter.Keyword,
        organization: 'GISAGRO'
      }
      let data = await this.User.requestResource('proxy/dol','POST',params);
      let land:any = {
        geometry: null,
        properties: {},
        type: 'Feature'
      };
      let mapping = require("../../../public/static/js/schemas").dol_mapping;
      for (let p in data) {
        switch (p.toLowerCase()) {
        case 'geojson':
          land.geometry = Object.assign({},data[p]);
          break;
        default: 
          let v = data[p];
          p = p.toLowerCase();
          if (mapping.hasOwnProperty(p)) {
            land.properties[mapping[p].name] = parseValue(v,mapping[p].dataType);
          } else {
            land.properties[p] = v;
          }
          break;
        }
      }
      land = this.$map.GeoJSONToFeatures(land, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      });
      this.$map.addFeaturesToLayer(land, "SearchFeatureLayer", {
        resetMapExtent: false
      });
      land = land[0];
      let prop = land.getProperties();
      let an3, an4, an5;
      if (prop.aag3_fk==10) {
        an3 = prop.province;
        an4 = 'เขต' + prop.amphoe;
        an5 = 'แขวง' + prop.tambon;
      } else {
        an3 = 'จังหวัด' + prop.province;
        an4 = 'อำเภอ' + prop.amphoe;
        an5 = 'ตำบล' + prop.tambon;
      }
      let area = '';
      if (prop.deed_rai) {
        area = prop.deed_rai + ' ไร่';
      }
      if (prop.deed_ngan || prop.deed_sqwah) {
        area += ' ' + prop.deed_ngan + ' งาน';
      }
      if (prop.deed_sqwah) {
        area += ' ' + prop.deed_sqwah + ' ตารางวา';
      }
      area = area.trim();
      let self = this;
      let info:any = {
        title: 'ที่ดิน',
        info: 'ใน' + an5 + ' ' + an4 + ' ' + an3 + ' เนื้อที่ ' + area,
        popup: {
          style: "width:300px",
          position: this.$map.getFeatureCentroid(land).map,
          offset: [0,-20],
          okText: 'addToGISagro',
          methods: {
            doAction(answer:string) {
              // "this" is the instance of PopUpUI
              this.closeMe();
              if (answer=='accept') {
                self.addDolLandToGISagro();
              }
            }
          },
          onClose: () => {
            self.$map.clearLayer('SearchFeatureLayer');
          }
        },
        feature: land
      }
      setTimeout(() => {
        this.$map.showInfoPopup(info.title, info.info, info.popup);
      }, 250);
      this.searchResults = [{
      name: prop.office_name,
      results: [{
          status: 0,
          title: 'ตำแหน่งที่ดิน',
          subTitle: prop.tambon + ' ' + prop.amphoe + ' ' + prop.province,
          info: info
        },{
          status: 'na',
          title: 'เลขที่โฉนด',
          subTitle: '(' + prop.aac4_fk + ')' + prop.deed_no_g
        },{
          status: 'na',
          title: 'เลขที่ที่ดิน',
          subTitle: prop.parcel_no
        },{
          status: 'na',
          title: 'ประเภทที่ดิน',
          subTitle: prop.deed_type_g
        },{
          status: 'na',
          title: 'เนื้อที่ (ไร่-งาน-ตร.ว.)',
          subTitle: prop.deed_rai + '-' + prop.deed_ngan + '-' + prop.deed_sqwah
        }]
      }];
      this.isSearching = false;
    } catch(error) {
      this.isSearching = false;
      this.searchResults = [{
        name: 'ไม่พบข้อมูลที่ต้องการ'
      }];
    }
  }

  addDolLandToGISagro() {
    let land = this.searchResults[0].results[0].info.feature;
    this.$map.hideInfoPopup();
    this.$map.clearLayer('SearchFeatureLayer');
    this.$map.addFeaturesToEditingLayers([land]);
    //let data = this.doSaveFeature('farmland', 'POST', land);
  }
}
